// ════════════════════════════════════════════════════════════════
//  SINGLE SOURCE OF TRUTH for the backend API URL.
//
//  Every URL comes from frontend/.env — change the domain THERE, never here
//  (a dev-server restart / rebuild is needed for .env changes to apply):
//
//    REACT_APP_API_BASE_URL   hosted backend API
//    REACT_APP_LOCAL_API_URL  local backend API
//    REACT_APP_SITE_URL       this frontend's own public URL
//
//  Every other frontend file must import API_BASE_URL from here
//  (or from utils/config.js, which re-exports it) — never hardcode
//  the backend URL anywhere else.
// ════════════════════════════════════════════════════════════════

const clean = (v) => String(v || "").trim().replace(/\/+$/, "");

export const LOCAL_API_URL = clean(process.env.REACT_APP_LOCAL_API_URL);
export const HOSTED_API_URL = clean(process.env.REACT_APP_API_BASE_URL);
export const SITE_URL = clean(process.env.REACT_APP_SITE_URL);

const isLocalEnvironment = typeof window !== "undefined" && (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "0.0.0.0"
);

if (!isLocalEnvironment && !HOSTED_API_URL) {
  // eslint-disable-next-line no-console
  console.warn("[apiConfig] REACT_APP_API_BASE_URL is not set in frontend/.env — falling back to", LOCAL_API_URL);
}
if (!LOCAL_API_URL) {
  // eslint-disable-next-line no-console
  console.warn("[apiConfig] REACT_APP_LOCAL_API_URL is not set in frontend/.env");
}

// On localhost → the local backend; anywhere else → the hosted backend from .env.
export const API_BASE_URL = isLocalEnvironment
  ? LOCAL_API_URL
  : (HOSTED_API_URL || LOCAL_API_URL);
